// extracted by mini-css-extract-plugin
export default {"chatTitle":"ChatTitle_chatTitle__3ubRW"};